import { createReducer, makeActionCreator } from "util/redux";

export const types = {
    DOWNLOAD_FILE_REQUEST: "files/DOWNLOAD_FILE_REQUEST",
    DOWNLOAD_FILE_SUCCESS: "files/DOWNLOAD_FILE_SUCCESS",
    GET_FILE_CONTENTS_REQUEST: "files/GET_FILE_CONTENTS_REQUEST",
    GET_FILE_CONTENTS_SUCCESS: "files/GET_FILE_CONTENTS_SUCCESS",
    DOWNLOAD_FILE_TEMPLATE_REQUEST: "files/DOWNLOAD_FILE_TEMPLATE_REQUEST",
    DOWNLOAD_FILE_TEMPLATE_FAILURE: "files/DOWNLOAD_FILE_TEMPLATE_FAILURE",
    DOWNLOAD_FILE_TEMPLATE_SUCCESS: "files/DOWNLOAD_FILE_TEMPLATE_SUCCESS",
};

export const INITIAL_STATE = {
    fetching: false,
    lines: [],
};

export default createReducer(INITIAL_STATE, {
    [types.DOWNLOAD_FILE_REQUEST]: () => ({ ...INITIAL_STATE, fetching: true }),
    [types.DOWNLOAD_FILE_SUCCESS]: (state) => ({
        ...state,
        fetching: false,
    }),
    [types.DOWNLOAD_FILE_TEMPLATE_REQUEST]: (state) => ({
        ...state,
        fetching: true,
    }),
    [types.DOWNLOAD_FILE_TEMPLATE_FAILURE]: (state) => ({
        ...state,
        fetching: false,
    }),
    [types.DOWNLOAD_FILE_TEMPLATE_SUCCESS]: (state) => ({
        ...state,
        fetching: false,
    }),
    [types.DOWNLOAD_FILE_REQUEST]: (state) => ({
        ...state,
        fetching: true,
    }),
    [types.DOWNLOAD_FILE_SUCCESS]: (state) => ({
        ...state,
        fetching: false,
    }),
});

export const actions = {
    getFileContentsRequest: makeActionCreator(
        types.GET_FILE_CONTENTS_REQUEST,
        "idFile",
        "deleteFile",
        "idUserCreator",
        "requestType",
        "idActivity",
    ),
    downloadFileRequest: makeActionCreator(types.DOWNLOAD_FILE_REQUEST, "idFile", "fileName", "idActivity"),
    downloadFileSuccess: makeActionCreator(types.DOWNLOAD_FILE_SUCCESS),
    downloadTemplate: makeActionCreator(
        types.DOWNLOAD_FILE_TEMPLATE_REQUEST,
        "idTemplate",
        "nameFile",
        "format",
        "notificationScope",
    ),
};

// Selectors
export const selectors = {
    isFetching: (state) => state.files.fetching,
};
